"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Count(props) {
  var i18n = props.i18n,
      offset = props.offset,
      limit = props.limit,
      total = props.total;


  return _react2.default.createElement(
    "div",
    { className: "result-count" },
    i18n.hotelSearch.resultCount.replace(/{start}/g, offset + 1).replace(/{end}/g, offset + limit < total ? offset + limit : total).replace(/{total}/g, total)
  );
} // Count

Count.propTypes = {
  i18n: _react.PropTypes.object.isRequired,
  offset: _react.PropTypes.number.isRequired,
  limit: _react.PropTypes.number.isRequired,
  total: _react.PropTypes.number.isRequired
};

exports.default = Count;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./src/components/Count.js
// module id = 1197
// module chunks = 0